import React from 'react';

const AboutAyushVatika: React.FC = () => {
  return (
    <section className="bg-white py-12 md:py-20 px-4 sm:px-6 lg:px-8 border-t border-gray-100 font-sans">

      
      <div className="max-w-7xl mx-auto">

        
        {/* Header Section */}
        <div className="border-b border-gray-200 pb-4 mb-8 flex justify-between items-center">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#334a21]">
            Know AyushVatika Better!
          </h2>
          {/* Optional minus icon just like the reference for aesthetic */}
          <span className="text-gray-400 text-3xl font-light hidden sm:block">-</span>
        </div>

        {/* SEO Rich Content Section */}
        <div className="text-gray-600 space-y-8 leading-relaxed text-sm md:text-base text-justify md:text-left">
          
          <p>
            <strong className="text-[#334a21]">AyushVatika</strong> is a leading manufacturer and one of the most trusted Ayurvedic brands in India, renowned for crafting premium, authentic, and results-driven herbal medicines and wellness products. Deeply rooted in the 5,000-year-old ancient wisdom of Ayurveda, our products are formulated with strict quality control and modern scientific validation. For years, we have been ethically sourcing the highest quality, micronutrient-dense herbs from the Himalayas and native Indian regions to promote holistic wellbeing. Hence, you can confidently buy authentic Ayurvedic medicines online directly from our website for your daily health needs.
          </p>

          <div>
            <h3 className="text-lg md:text-xl font-bold text-[#334a21] mb-3">
              What Does This Ayurvedic Company Do?
            </h3>
            <p>
              We at AyushVatika believe in the power of natural healing. We are dedicated to delivering the unadulterated goodness of Ayurveda straight to your doorstep. Our vision is to create Ayurvedic solutions that promote deep healing, naturally and safely. From our highly effective joint care oils like <em>Asthi Shudhi Telam</em> and heart care formulas like <em>Hriday Vallabh Rasayan</em>, to pure extracts of Shilajit and Ashwagandha, we offer a comprehensive range of natural health solutions. All our products are backed by the profound knowledge of expert Vaidyas, decades of research, and stringent quality checks to ensure you get nothing but the best.
            </p>
          </div>

          <div>
            <h3 className="text-lg md:text-xl font-bold text-[#334a21] mb-3">
              What Makes AyushVatika Different?
            </h3>
            <p>
              At AyushVatika, we don't just manufacture and sell Ayurvedic medicines online; we preserve a sacred legacy. What makes us truly unique is our unwavering commitment to purity, transparency, and ethical sourcing. We blend ancient Ayurvedic wisdom with modern wellness needs, creating effective remedies trusted by thousands. Every product carries the essence of nature, extracted using traditional whole-plant methods without the use of harsh chemical solvents. We proudly operate out of GMP-certified, ISO-approved facilities, ensuring our formulations are 100% natural, cruelty-free, and completely free from harmful heavy metals, parabens, and toxins.
            </p>
          </div>

          <div>
            <h3 className="text-lg md:text-xl font-bold text-[#334a21] mb-3">
              Buy Authentic Ayurvedic Medicines & OTC Products Online
            </h3>
            <p>
              Finding genuine, unadulterated Ayurvedic products online can be challenging, but AyushVatika makes it seamless and secure. As one of the fastest-growing Ayurvedic companies in India, we bring centuries-old healing wisdom to your home through convenient, modern shopping. We offer a safe online purchasing experience with multiple payment options, secure Cash on Delivery (COD), and fast shipping across India. Trust AyushVatika to be your lifelong partner in health, vitality, and holistic living. Experience the ultimate synergy of mind, body, and spirit with our clinically proven, Vaidya-formulated remedies.
            </p>
          </div>

        </div>
      </div>


       {/* 3. Our Story Section */}
      <section className="bg-[#79a34a] text-white py-12 px-6 mt-16">
        <div className="max-w-8xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6 border-b-2 border-white/30 pb-4 inline-block">
            Our Story, Your Journey to Health
          </h2>
          <div className="text-sm md:text-base leading-relaxed space-y-4 text-left md:text-center opacity-95">
            <p>
              When I first embarked on the journey to create <strong>Zenius</strong>, it wasn't just about launching another brand in the crowded wellness space. It was deeply personal — rooted in my own quest for Ayurvedic care balance, vitality, and holistic health. Like many of us, I witnessed friends and family struggling with everyday health challenges.
            </p>
            <p>
              Growing up, Ayurveda was always part of my life. I realized something had to change. That's how Zenius was born — a brand dedicated to bringing authentic Ayurvedic medicine directly to you, in a way that fits modern lifestyles. We blend tradition with technology.
            </p>
            <p>
              From men's care to women's wellness, every segment is thoughtfully curated to meet your unique needs. Our mission is simple: empower you to take control of your health with natural solutions.
            </p>
          </div>
        </div>
      </section>

    </section>
  );
};

export default AboutAyushVatika;